import { Link } from "react-router-dom";
import { Sparkles, BookOpenText } from "lucide-react";

export default function Nav() {
  return (
    <header className="sticky top-0 z-40 backdrop-blur-md bg-[#faf6ee]/85 border-b border-[#e8dfd1]">
      <nav className="max-w-6xl mx-auto flex items-center justify-between px-5 py-4">
        <Link to="/" data-testid="nav-logo" className="flex items-center gap-2">
          <span className="w-9 h-9 rounded-2xl bg-[#E07A5F] text-white flex items-center justify-center shadow">
            <BookOpenText size={18} />
          </span>
          <span className="font-display text-2xl font-black tracking-tight text-[#2B2D42]">
            Story<span className="text-[#E07A5F]">Forge</span>
          </span>
        </Link>
        <div className="flex items-center gap-2 sm:gap-4">
          <Link to="/library" data-testid="nav-library"
                className="text-sm font-semibold text-[#2B2D42] hover:text-[#E07A5F] hidden sm:inline">
            My Library
          </Link>
          <Link to="/create" data-testid="nav-cta"
                className="pill-tag bg-[#2B2D42] text-white hover:bg-[#3D405B] flex items-center gap-1">
            <Sparkles size={14} /> Create your book
          </Link>
        </div>
      </nav>
    </header>
  );
}
